
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/lists",
      function () {
        return require("private-next-pages/search/lists.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/lists"])
      });
    }
  